import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const babyNightCrying: BlogMetaData = {
  title: '夜泣き対策｜月齢別の原因とモンテッソーリ流・安眠環境の整え方（生後4ヶ月〜1歳）',
  description:
    '夜泣きが続いてつらい…。生後4ヶ月・6ヶ月・9ヶ月・1歳と月齢別に原因を整理し、モンテッソーリ教育の環境論をもとに今日から実践できる対策を5つ解説。放置していいか・いつまで続くかの疑問にも答えます。',
  thumbnailUrl: '/img/blog-baby-night-crying.webp',
  filePath: buildBlogFilePath('baby-night-crying'),
  category: BLOG_CATEGORY.PARENTING,
};
